/**
 * Single source of truth for the AdSense loader. Both gatsby-ssr.js (initial
 * render) and gatsby-browser.js (client-side navigation) read from here so the
 * two gates cannot drift apart.
 */

export const AD_CLIENT = "ca-pub-8507137850188161";

export const ADSENSE_SCRIPT_SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT}`;

/**
 * Pages that carry ads: both homepages and the blog.
 *
 * The blog is English-only — /pt/blog and /pt/blog/* are 301'd to /blog/*
 * (see redirects.json), so no Portuguese blog prefix is matched here.
 */
export const isAdRoute = (pathname = "") => {
  const path = pathname.split("?")[0].split("#")[0];
  // An empty pathname is bad input, not the home page: don't normalise it to "/".
  if (!path.startsWith("/")) return false;

  const normalised = path.endsWith("/") ? path : `${path}/`;

  return (
    normalised === "/" ||
    normalised === "/pt/" ||
    normalised.startsWith("/blog/")
  );
};

/**
 * Manually placed units, created in the AdSense dashboard on 2026-08-25.
 * Auto ads' in-page formats are switched off for this site, so these are the
 * only in-page ads anywhere; the anchor and side-rail overlays still come from
 * Auto ads and need no slot here.
 */
export const AD_SLOTS = {
  blogRailLeft: "3334505650",
  blogRailRight: "3793670656",
  blogInArticle: "6433215789",
  homeBeforeFooter: "2346631113",
} as const;
